"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockedTokenProvider = void 0;
/** @deprecated Please import from @ori/auth/mocked */
const MockedTokenProvider = ({
  children
}) => children;
exports.MockedTokenProvider = MockedTokenProvider;
